import React from "react";
import { NavLink } from "react-router-dom";
import { LogoutButton } from "../topbar/NavBar";
import "../../../center admin css/centerAdmin.css"

type TopBarProps = {
  logoSrc?: string;
  tabs?: string[];
  /** Optional: override a tab → path mapping */
  linkForTab?: (tab: string) => string;
  onLogout?: () => void;
};

/** Default paths aligned with App.tsx */
const defaultTabRoutes: Record<string, string> = {
  Dashboard: "/welcome_screen",
  "Check-In": "/check-view",
  "Growth Chart": "/growth-chart",
  "Lab Pick-Up": "/lab-pick-up",
  "Lab Reports Entry": "/lab-reports-entry",
  "B&U sample": "/bu-sample",
  "Nurse 1": "/nurse-1",
  "Nurse 2": "/nurse-2",
  "Nurse 3": "/nurse-3",
};

const defaultTabs = [
  "Dashboard",
  "Check-In",
  "Growth Chart",
  "Lab Pick-Up",
  "Lab Reports Entry",
  "B&U sample",
  "Nurse 1",
  "Nurse 2",
  "Nurse 3",
];

const TopBar: React.FC<TopBarProps> = ({
  logoSrc,
  tabs = defaultTabs,
  linkForTab,
  onLogout,
}) => {
  const toFor = (tab: string) =>
    linkForTab ? linkForTab(tab) : defaultTabRoutes[tab] ?? "#";

  return (
    <div className="topbar">
      <div className="topbar__brand">
        {logoSrc && <img src={logoSrc} alt="Qavach" className="topbar__logo" />}
        <nav className="topbar__tabs" aria-label="Primary">
          {tabs.map((tab) => (
            <NavLink
              key={tab}
              to={toFor(tab)}
              end
              className={({ isActive }: { isActive: boolean }) =>
                "topbar__tab" + (isActive ? " topbar__tab--active" : "")
              }
            >
              {tab}
            </NavLink>
          ))}
        </nav>
      </div>
      <LogoutButton />

      {/* {onLogout && (
        <button className="topbar__logout" onClick={onLogout}>
          <span className="topbar__logout-icon" aria-hidden>
            ➜]
          </span>
          Logout
        </button>
      )} */}
    </div>
  );
};

export default TopBar;
